import Vue from 'vue';
import { CartItem } from '@/store/models';



const sumProdValues = (products: any[]) => {
    return products.reduce((sum,product) => {
        return sum + parseFloat(product.price)  * product.quantity;
    },0.0);
};


/**
 * Push method abstraction
 * @param dataLayer object
 */
const gtmPush = (dataLayer: object) => {
    // @ts-ignore
    if (Vue.gtm) {
        // @ts-ignore
        Vue.gtm.push(dataLayer);
    }
};


/**
 * Convert cart item model to gtm product model
 * @param products CartItem[]
 * @returns any [];
 */
const convertProductsData = (products: CartItem[]) => {
    const productsData: any[] = [];

    if (products.length > 0) {
        products.forEach((product) => {
            var productdata = JSON.parse(product.extension_attributes.extgtm_data);
            productdata.quantity = product.qty;
            productsData.push(productdata);
        });
    }

    return productsData;
};

const convertSinglePrice = (products: any[]) => {

    products.forEach((product) => {
        var price = parseFloat(product.price);
        if(product.hasOwnProperty("singleNetPrice")) {
            price = parseFloat(product.singleNetPrice);
        }
        var discount = parseFloat(product.discount);
        if(product.hasOwnProperty("singlePrice")) {
            discount = parseFloat(product.singlePrice) - price;
        }
        product.price = price.toFixed(2);
        product.discount = discount.toFixed(2);
    });

    return products;
};

const removeUnwantedData = (products: any[]) => {
    products.forEach((product) => {
        if(product.hasOwnProperty("singlePrice")) {
            delete product.singlePrice;
        }
        if(product.hasOwnProperty("singleNetPrice")) {
            delete product.singleNetPrice;
        }
    });
    return products;
};


const trackViewCart = (
    products: any[],
    total: number,
    currency: string,
    coupon: string
) => {
    const dataLayer = {
        event: "view_cart",
        ecommerce: {
            currency: currency,
            value: total.toFixed(2),
            coupon: coupon ? coupon.toLowerCase() : "",
            items: removeUnwantedData(products)
        },
    };

    gtmPush(dataLayer);
};

const trackBeginCheckout = (
    products: any[],
    total: number,
    currency: string,
    coupon: string
) => {
    const dataLayer = {
        event: "begin_checkout",
        ecommerce: {
            currency: currency,
            value: total.toFixed(2),
            coupon: coupon ? coupon.toLowerCase() : "",
            items: removeUnwantedData(products)
        },
    };

    gtmPush(dataLayer);
};

const trackShippingInfo = (
    products: any[],
    total: number,
    currency: string,
    coupon: string,
    shippingTier: string
) => {
    const dataLayer = {
        event: "add_shipping_info",
        ecommerce: {
            currency: currency,
            value: total.toFixed(2),
            coupon: coupon ? coupon.toLowerCase() : "",
            shipping_tier: shippingTier,
            items: removeUnwantedData(products)
        },
    };

    gtmPush(dataLayer);
};

const trackBillingInfo = (
    products: any[],
    total: number,
    currency: string,
    coupon: string
) => {
    const dataLayer = {
        event: "add_invoice_info",
        ecommerce: {
            currency: currency,
            value: total.toFixed(2),
            coupon: coupon ? coupon.toLowerCase() : "",
            items: removeUnwantedData(products)
        },
    };

    gtmPush(dataLayer);
};

/**
 * track  product addition to cart
 * @param products any[]
 */
const trackAdd = (
    products: any[],
    currency: string,
) => {
    products = convertSinglePrice(products);
    const dataLayer = {
        event: 'add_to_cart',
        ecommerce: {
            currency: currency,
            value: sumProdValues(products).toFixed(2),
            items: removeUnwantedData(products),
        },
    };

    gtmPush(dataLayer);
};


/**
 * track product removal from cart
 * @param products any[]
 */
const trackRemove = (
    products: any[],
    currency: string
) => {
    products = convertSinglePrice(products);
    const dataLayer = {
        event: 'remove_from_cart',
        ecommerce: {
            currency: currency,
            value: sumProdValues(products).toFixed(2),
            items: removeUnwantedData(products),
        },
    };

    gtmPush(dataLayer);
};

const trackAddToWishlist = (
    products: any[],
    currency: string,
) => {
    products = convertSinglePrice(products);
    const dataLayer = {
        event: 'add_to_wishlist',
        ecommerce: {
            currency: currency,
            value: sumProdValues(products).toFixed(2),
            items: removeUnwantedData(products),
        },
    };

    gtmPush(dataLayer);
};



const trackSuccessApplyCoupon = (
) => {
    const dataLayer = {
        event: 'apply_coupon_success',
    };

    gtmPush(dataLayer);
};

const trackFailedApplyCoupon = (
) => {
    const dataLayer = {
        event: 'apply_coupon_error',
    };

    gtmPush(dataLayer);
};

const trackSetPaymentMethod = (
    products: any[],
    total: number,
    currency: string,
    coupon: string,
    paymentType: string,
) => {
    const dataLayer = {
        event: "add_payment_info",
        ecommerce: {
            currency: currency,
            value: total.toFixed(2),
            coupon: coupon ? coupon.toLowerCase() : "",
            payment_type: paymentType,
            items: removeUnwantedData(products)
        },
    };

    gtmPush(dataLayer);
};

const trackPlaceOrder = (
) => {
    const dataLayer = {
        event: 'place_order',
    };

    gtmPush(dataLayer);
};

const trackUserEvent = (
    dataLayer: any
) => {
    dataLayer.event = "userEvent";
    gtmPush(dataLayer);
};

const trackPromoCarouselShow = (
    eventName: string,
    promoType: string,
) => {

    const dataLayer = {
        event: eventName,
        promo_type: promoType,
    };

    gtmPush(dataLayer);
};

const trackSimpleEvent = (
    eventName: string,
) => {

    const dataLayer = {
        event: eventName,
    };

    gtmPush(dataLayer);
};

export default {
    convertProductsData,
    gtmPush,
    trackAdd,
    trackViewCart,
    trackBeginCheckout,
    trackShippingInfo,
    trackBillingInfo,
    trackRemove,
    trackAddToWishlist,
    trackSuccessApplyCoupon,
    trackFailedApplyCoupon,
    trackSetPaymentMethod,
    trackPlaceOrder,
    trackUserEvent,
    trackPromoCarouselShow,
    trackSimpleEvent
};

